import React from "react";
import { Link } from "react-router-dom";

function BannerFour() {
  return (
    <div className="homepage-banner">
      {/* tmp banner area start */}
      <div className="tmp-section-gap tmp-banner__agency-wrapper-bg position-relative bg_image">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="banner-inner-content-four"
                style={{ zIndex: "1", position: "relative" }}
              >
                <div className="inner-content-banner-four">
                  <div className="content-wrapper">
                    <h1
                      className="title wow fadeInUp"
                      data-wow-duration=".8s"
                      data-wow-delay=".3s"
                    >
                      Build. Grow. Succeed
                      <br /> <span> Expert Business & Tax Consulting</span>{" "}
                    </h1>
                    <p
                      className="disc wow fadeInUp"
                      data-wow-duration=".8s"
                      data-wow-delay=".5s"
                    >
                      From formation to payroll and tax, we provide reliable financial solutions that simplify operations and strengthen your business.
                    </p>


                    <div className="disc wow fadeInUp"
                      data-wow-duration=".8s"
                      data-wow-delay="0.8s">
                      <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
  <svg width="0" height="0" style={{ position: "absolute" }}>
    <defs>
      <linearGradient id="goldGrad3d" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#fff4b3" />
        <stop offset="35%" stopColor="#fbbf24" />
        <stop offset="65%" stopColor="#d69e00" />
        <stop offset="100%" stopColor="#a66a00" />
      </linearGradient>
      <linearGradient id="shineGrad3d" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.55" />
        <stop offset="25%" stopColor="#ffffff" stopOpacity="0" />
        <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
      </linearGradient>
      <filter id="dropShadow3d" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#000" floodOpacity="0.35" />
      </filter>
      <filter id="innerShadow3d" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="1.5" result="blur" />
        <feOffset dx="0" dy="0" result="offsetBlur" />
        <feComposite in="offsetBlur" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="innerShadow" />
        <feComposite in="SourceGraphic" in2="innerShadow" operator="over" />
      </filter>
    </defs>
  </svg>

  {(() => {
    const rating = 4.4;
    const full = Math.floor(rating);
    const frac = Math.max(0, Math.min(1, rating - full));
    const path = "M50 4 L61 35 L94 38 L69 58 L77 90 L50 72 L23 90 L31 58 L6 38 L39 35 Z";

    return Array.from({ length: 5 }).map((_, i) => {
      const pct = i < full ? 100 : i === full ? Math.round(frac * 100) : 0;
      const isPartial = i === full && frac > 0;
      return (
        <svg
          key={i}
          viewBox="0 0 100 100"
          width="26"
          height="26"
          style={{ filter: "url(#dropShadow3d)" }}
        >

          <path d={path} fill="#ffffff" opacity="0.8" />

          <clipPath id={`clip-${i}`}><rect x="0" y="0" width={pct} height="100" /></clipPath>
          <g clipPath={`url(#clip-${i})`}>
            <path d={path} fill="url(#goldGrad3d)" filter="url(#innerShadow3d)" />
            <path d={path} fill="url(#shineGrad3d)" opacity="0.35" />
          </g>

          {/* crisp outline */}
          <path d={path} fill="none" stroke="#000" strokeOpacity="0.25" strokeWidth="1.2" />
        </svg>
      );
    });
  })()}

  <span style={{ color: "#fff", fontWeight: 600, fontSize: 16, letterSpacing: 0.2 }}>4.4</span>
</div>
                    </div>



                    <div
                      className="button-area-banner-one wow fadeInUp"
                      data-wow-duration=".8s"
                      data-wow-delay=".7s"
                    >
                      <Link to={"/Service"} className="tmp-btn btn-primary">
                        <i
                          style={{ transform: "rotate(-44deg)" }}
                          className="fa fa-arrow-right"
                        />{" "}
                        Explore More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="tmp-ocean">
          <div className="ocean">
            <div className="wave" />
            <div className="wave" />
          </div>
        </div> */}
      </div>
      {/* tmp banner area end */}
    </div>
  );
}

export default BannerFour;
